import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/Users/brandonwu/Documents/PTS/Gatsby/Instana-1-Day-Partner-Workshop/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const Title = () => <span>
    Instructor Setup Instructions <br />
  </span>;
;
export const _frontmatter = {};
const layoutProps = {
  Title,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1>{`Creating Virtual Machines for class`}</h1>
    <p>{`Email Doug Slade (`}<a parentName="p" {...{
        "href": "mailto:dugslade@us.ibm.com"
      }}>{`dugslade@us.ibm.com`}</a>{`) with any questions or for access.`}</p>
    <h2>{`Step 1:`}</h2>
    <p>{`Navigate and login to IBM Cloud.`}</p>
    <h2>{`Step 2:`}</h2>
    <p>{`Go to sidebar then Classic > Devices > Manage > Images `}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "61.80555555555556%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAABYlAAAWJQFJUiTwAAABvElEQVQoz61Sz4vTUBB+/4VLm5u7bY2izUJBwfW/WLwuoof9NxYv62nx2qr06EEMTfPyEroU6v+g7LLgVT0kTd5LQ5sfn8ysCOJBqQY+vnlv5n0zkxmhpIRUEebzORaLBWbn5/CmPjxvCm8q4fkSMlAIlIJSAfwgZP/UdTGZeHAnHt67E7al70Ps7Xawc2MHh4ePcXLyHGdnLzGbzRBFEaIwuma2Q0RRyLYKAgRBwKyUQhgqSKnwzlUQBweP0O/3cf/BQ9y+4+Dps2OkaYY4jpFl2TXSDDrTyDINrTXfGWM4TmuDutog1hXefthADAYD2LYNx3Fg27dwdPQEcZrjy7evyI1hgeVyyQIklOc5kiTBarXipMR0Jn9RrCD2nX1YloXT0xe4uLzCp4srrMsG680a9NV1jaqq0NQN203ToCzLX5j8HNM0EFRdu93GeDxmgaIoOBtlpmr+FvSGWHS7XVhWG8PhkDNQ+dTmthC9Xo9bHo1GXGGappxtW/wXQZq0+THA3wRpotu0amidSLDT6aDVavE//JeWtTFYFwbi7r0+bu7u4dXrNyirCnGS8MISfi72H0Cxucnw8XOK73/fNddQDse8AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "lab image",
        "title": "lab image",
        "src": "/Instana-1-Day-Partner-Workshop/static/196092543f128d61694f74b1ff593548/3cbba/1.png",
        "srcSet": ["/Instana-1-Day-Partner-Workshop/static/196092543f128d61694f74b1ff593548/7fc1e/1.png 288w", "/Instana-1-Day-Partner-Workshop/static/196092543f128d61694f74b1ff593548/a5df1/1.png 576w", "/Instana-1-Day-Partner-Workshop/static/196092543f128d61694f74b1ff593548/3cbba/1.png 1152w", "/Instana-1-Day-Partner-Workshop/static/196092543f128d61694f74b1ff593548/0b124/1.png 1728w", "/Instana-1-Day-Partner-Workshop/static/196092543f128d61694f74b1ff593548/5e957/1.png 1822w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <h2>{`Step 3:`}</h2>
    <p>{`Click on InstanaPOTStudentVMImages (old-> ausptw-mar22-master) which is the master image `}</p>
    <h2>{`Step 4:`}</h2>
    <p>{`Go to top right corner and click Actions > Order Public VSI`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "61.80555555555556%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAABYlAAAWJQFJUiTwAAABc0lEQVQoz4VSOW7DMBDkp/OIFHlAnuDGscxDtJ8QpEnnIk2qAA50UDx0WNIES1u2EPgQMFiC4s7s7C7jXIALBa010lRDSgUuJLgQ4FJBEIREmqbxjVAalCNWCdZcYLXmeEs4dCqQKgm2XK6wWCyQJAm2221M2mgd4zUQsRQCSkpIKaHUUfDpWeLlVYCFUONwOKDvezz6hmG4ek8cv2ZA6ABmTIWqqpBlGdq2xTiOsNaiaZpIQEIUSXS/3yPPcxRFEeMcwVcI3oI56+CcQ1mW6LouKnrvz4Tz6uhdXdcRJD6HtS7mMRsJfVQhkqOFEH+SABFNFVLlj8CsO1ZINuiC1IlwinOQyD0Qz6lCh7wokGUFytLAmNugXlN7qO9T/+hcnPIYkVFlzgdY36Ju2jiIW6A2zAd12ZAeGNpZhXkeFSZr/+3eQx08Pr8sdt/Rsj1PeVqHe5avwVYGm/ccH7vyYnmyMg7jebq0kw8R39F6jfjJGvwBrICDx23lCJwAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "lab image",
        "title": "lab image",
        "src": "/Instana-1-Day-Partner-Workshop/static/685e1d7e9d0eba14375b3a318b3e595a/3cbba/2.png",
        "srcSet": ["/Instana-1-Day-Partner-Workshop/static/685e1d7e9d0eba14375b3a318b3e595a/7fc1e/2.png 288w", "/Instana-1-Day-Partner-Workshop/static/685e1d7e9d0eba14375b3a318b3e595a/a5df1/2.png 576w", "/Instana-1-Day-Partner-Workshop/static/685e1d7e9d0eba14375b3a318b3e595a/3cbba/2.png 1152w", "/Instana-1-Day-Partner-Workshop/static/685e1d7e9d0eba14375b3a318b3e595a/0b124/2.png 1728w", "/Instana-1-Day-Partner-Workshop/static/685e1d7e9d0eba14375b3a318b3e595a/fde92/2.png 1824w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <h2>{`Step 5:`}</h2>
    <p>{`Create a host name that is appropriate to the location of the class `}</p>
    <h2>{`Step 6:`}</h2>
    <p>{`Choose quantity (20 Max).`}</p>
    <p>{`Change billing rate to Hourly.`}</p>
    <p>{`Change profile to B1 2x8.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "61.11111111111111%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAABYlAAAWJQFJUiTwAAACJklEQVQoz5WTSU4bQRiF+yAMi2AxLByDE8IVAAWbhEWwcgMuxCmIu9vuWB4QVmCBuEOUBIIiLNNDDd0Ntr+oC2OGJIv80lNNr169v/4qy7ZtbKeG53nUPY9arY7j1nGcGo7r4da8ydh1a9iuh207OAdVqrbLQdXhU9U1/W73C9bnRot6vU6z2aTT6dBoNDg6OuLk5ITj4+O/otvtGs7Z2Rn7+/vkcjmmpqZYX1/HGgwGZDEajvivGNNPT08prhTJzeUobZWweld9/OuQKFRIERMFAhkplFCmr4Q27XP4/ZDh7Yh2s8NKocjS/BI773aw+l+/cfXjkuD8J37vmiBShEGIVppYxyilkUL+gTCMjMNWq83iwiJzL+bYeruFJc6/07/IBM+Rfh+hFEJIhBCPIBHyKcIwNILtdpt8vsD8/ALlchkrEgKtNVJK/CAgiiIjouMYPwxRcWzWsrmsfXAYjh22yL98Rb5QpFQqY4mxYBzHhpQkiXGgss39HqrfQ2aHyKeuM+5oNOLw8JDt7fd8qHxkb28PS0R3gmmaMhwOuUlTBsMht7Hm5tcl6eUFwr9GqLGgvIMRZGSe2traG1ZXX7O7u4slpSJJUnRWAJ0ghELrBKVidHJDnKTGnbxPeYzHKc/OzjI9Pc3m5iaW7/tm0ZCicQEmEIhIPCvQQ8pZZB9iZmbGCG5sbGAFQYBSanLxWVEy3M/9Cxkni+zHLC8vUygUqFQq/AYtxjZdNfQLDAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "lab image",
        "title": "lab image",
        "src": "/Instana-1-Day-Partner-Workshop/static/66189d6ea1806f5b2cd300a92014b79d/3cbba/3.png",
        "srcSet": ["/Instana-1-Day-Partner-Workshop/static/66189d6ea1806f5b2cd300a92014b79d/7fc1e/3.png 288w", "/Instana-1-Day-Partner-Workshop/static/66189d6ea1806f5b2cd300a92014b79d/a5df1/3.png 576w", "/Instana-1-Day-Partner-Workshop/static/66189d6ea1806f5b2cd300a92014b79d/3cbba/3.png 1152w", "/Instana-1-Day-Partner-Workshop/static/66189d6ea1806f5b2cd300a92014b79d/0b124/3.png 1728w", "/Instana-1-Day-Partner-Workshop/static/66189d6ea1806f5b2cd300a92014b79d/416da/3.png 1826w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "61.11111111111111%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAABYlAAAWJQFJUiTwAAACL0lEQVQoz2WTa4+aQBSG+bu7Tf2w/RFYXQYvdPsT/LgXQJAYjVFbbdKfsN6wX7yAgAsKtm9zjos26SQn78xw5p0n5wySZVkwmxYcx0HLcWDbLRimBV03YRgWDKPJoesGDMOEblg81x+f8aKbeHo28Pikv+c3IRUKBdze3KBQ+IhPd3f4cHuLer2ObreLdruNXq/3X3Q6Hf6eB687Z5VqdQ3Vmob6lwdoD18hhIrRaIR8xHGCw+HAkWYp6/F4ZE2SBGma8prmNCRVreBzSUGprECoKuRikcniOOak9XqNzWaD1WoF3/fheR622y3vkdIeKeXRGUlVVdwrAooQUIVAsVhkdLqVYrfbIQxD1v1+jyiKeE1Bc94LQwRBwLRStVpFtVpBpVKBoigolUpcF6KjZCLy/R1TkEF+OL+IcoIgZNLj8d2QzGq1GjRNQ7lcxmAw4Hr8S0gmOWFOeSGMoithjQnPQYZEeDVMsV5vLjUi0msdPfiezxd6no/NZsuN4hoKoTAlNUiWi+j3+2z4Fid4fZ1gPpthMpnAdZdwXReL+QLz2RzuwsVy+QuLxQLT6ZSpJSEE146UzKkp9NZoUB3zThJVGAZcr10QwfcD1jB6Y/X8AMkhhURkZzqVVZZljMfjyzvMsgyn0wlZmp43fmf4kwYcyELgFAFpgNPBB0CG6tmQlJ9Q+R6NRgPD4ZC7Tb+mbdtoWhacVhOt7g8Y4xgv3wIYowjmeA/9e8hr++cBfwHqtzGazdVIawAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "lab image",
        "title": "lab image",
        "src": "/Instana-1-Day-Partner-Workshop/static/21db1e7de18821a632a262569f216fa5/3cbba/4.png",
        "srcSet": ["/Instana-1-Day-Partner-Workshop/static/21db1e7de18821a632a262569f216fa5/7fc1e/4.png 288w", "/Instana-1-Day-Partner-Workshop/static/21db1e7de18821a632a262569f216fa5/a5df1/4.png 576w", "/Instana-1-Day-Partner-Workshop/static/21db1e7de18821a632a262569f216fa5/3cbba/4.png 1152w", "/Instana-1-Day-Partner-Workshop/static/21db1e7de18821a632a262569f216fa5/0b124/4.png 1728w", "/Instana-1-Day-Partner-Workshop/static/21db1e7de18821a632a262569f216fa5/fde92/4.png 1824w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <h2>{`Step 7:`}</h2>
    <p>{`Click the Create button in the right-hand sidebar `}</p>
    <h1>{`Once Virtual Machines are Created`}</h1>
    <h2>{`Step 1:`}</h2>
    <p>{`Search devices for “aiops-”`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "61.11111111111111%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAABYlAAAWJQFJUiTwAAABsElEQVQoz52SzW7TQBSF/RQVwlbIqrJDlpQN8FAg8Sjd4QT2QBP/xkk3LHiDClSUhF2ltiQez4wnroL6ITuhhGUy0tG5d4505lzdsaIwJIxS0tGYJM2IkpQgSgiimCBOCeOUOB01WpqOCJOMYRgTDIYMgoizIOLTWcBgOCSOQyzXdTk6esTb12/4Mp4wjiImccx5kjT8gOhfnYUhoyBouMZ5ljHKJnwejrFevnjF8bHLh9NT5GzO1cU3rr9fcnv5g3w2ZzmbsZhON/V09sBi/nPTT2espeCXvOfj1zusk2cnPHHa9P333P2Gq5uc21xxu1hgVit0aSikpDQGVZbNXd2vqopciIaFEBhjqKpVbficlt2i967Hen3P9U3OYlmwzHOUUshCUgiBlBJZFCgpEVstX+YoqRrDotaUwup0uth2C9/vU5+ikGhdUpZmLyil0drUS+n8ZyiEQqnyAJiGLc99ivN4N6FqXjoUlud6OLaD7/e2hgVa672wGXfDlud5OE5t6G8NBVqrvVAv4y83H9u27R3D/RKqnZSVUVjdbpd2u02/3z9sZLVJVhnNxVzxB2BIPfCfJeQtAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "lab image",
        "title": "lab image",
        "src": "/Instana-1-Day-Partner-Workshop/static/4e7996858f403a7504ba5c65083b06ef/3cbba/image5.png",
        "srcSet": ["/Instana-1-Day-Partner-Workshop/static/4e7996858f403a7504ba5c65083b06ef/7fc1e/image5.png 288w", "/Instana-1-Day-Partner-Workshop/static/4e7996858f403a7504ba5c65083b06ef/a5df1/image5.png 576w", "/Instana-1-Day-Partner-Workshop/static/4e7996858f403a7504ba5c65083b06ef/3cbba/image5.png 1152w", "/Instana-1-Day-Partner-Workshop/static/4e7996858f403a7504ba5c65083b06ef/0b124/image5.png 1728w", "/Instana-1-Day-Partner-Workshop/static/4e7996858f403a7504ba5c65083b06ef/a91d8/image5.png 1820w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <h2>{`Step 2:`}</h2>
    <p>{`Click on VM Image and go to Password tab`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "38.888888888888886%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAABYlAAAWJQFJUiTwAAABPUlEQVQoz52Q307CMBTG+/43GhN1sGV7Cl/AK1nbsUGIN8bEC9jWba6jXQEVPtNOkOgdTX4553zn6+kfQhlFkmbIshmSaQqeTBEzjpgyUJaA8gQx5WCMI00zJOnM6WwSYxIzTCjHU8wGP+cgt3cjXF3fwLv34Ps+PM/GwOVBECAMI4Rh6IiiyOF647GLfhA4v50zGgUgu90nvvYHGLPBeq1gjMF+f8CliwghILsOdV1DiApN0ziklOi6DrZvsbnV2lZCyiE/1lpJPKYNxg81SJ4XeG9bFEWB1WrlNttYliWausF8PsdisXCHWM9yuURV1ahEhTwvUZYCdVXh9a3A80sJopTGWmlobenR9xbjnm7jdrtzHLVzevPr22wMPrYGxA7R2kCp/gf9B+X+9r9+Tn+C6FMxDNVaXcBwKcs3Mi9H0DnOlcUAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "lab image",
        "title": "lab image",
        "src": "/Instana-1-Day-Partner-Workshop/static/f8785bc4b2fa142b53edb2778eec95cc/3cbba/image6.png",
        "srcSet": ["/Instana-1-Day-Partner-Workshop/static/f8785bc4b2fa142b53edb2778eec95cc/7fc1e/image6.png 288w", "/Instana-1-Day-Partner-Workshop/static/f8785bc4b2fa142b53edb2778eec95cc/a5df1/image6.png 576w", "/Instana-1-Day-Partner-Workshop/static/f8785bc4b2fa142b53edb2778eec95cc/3cbba/image6.png 1152w", "/Instana-1-Day-Partner-Workshop/static/f8785bc4b2fa142b53edb2778eec95cc/0b124/image6.png 1728w", "/Instana-1-Day-Partner-Workshop/static/f8785bc4b2fa142b53edb2778eec95cc/18f13/image6.png 1818w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <h2>{`Step 3:`}</h2>
    <p>{`SSH into each machine using the given password and change it to something more secure.`}</p>
    <ul>
      <li parentName="ul">{`ssh root@(machine-ip)`}</li>
      <li parentName="ul">{`passwd ubuntu`}</li>
      <li parentName="ul">{`(enter new ubuntu password `}{`[Do not use common password like “ubuntu”]`}{`)`}</li>
    </ul>
    <p>{`You can exit and SSH into machine again and verify ubuntu password works.`}</p>
    <ul>
      <li parentName="ul">{`ssh ubuntu@(machine ip)`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      